import { useNavigate } from "react-router-dom";
import Navbar from "../../components/navbar/navbarComponent";
import { ingresoDetalles } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Button from "../../components/button";

function IngresoDetallesComponent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const datosConfirmarIngreso = useSelector((state) => state.datosConfirmarIngreso);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleback = (e) => {
    e.preventDefault();
    navigate(-1);
  };


  const onSubmit = async (data) => {
    /* const resp =  */await dispatch(ingresoDetalles(data));

    navigate("/opciones_ingreso_foto");
  };


  return (
    <div>
      <Navbar />
      <div className="flex min-h-screen flex-col  items-center bg-[#F5FAFF] gap-8">
        <div class="flex flex-col justify-center items-start sm:items-center mt-[1rem] sm:mt-[4rem] w-[20rem] sm:w-[32rem]">
          <div class="text-[#3d4245] sm:text-[2rem] text-[1rem] font-bold font-inter">
            Nuevo ingreso
          </div>
          <div class="text-[#687073] sm:text-lg text-s font-medium font-inter">
            Ingresa un nuevo vehículo al corralón
          </div>
        </div>

        <div className="w-[20rem] sm:w-[32rem] flex-col justify-start items-start gap-1 inline-flex">
          <div className="self-stretch justify-start items-center inline-flex">
            <div className="w-[33.40px] h-[33.40px] px-[5.01px] py-[6.68px] bg-[#0477ad] rounded-[33.40px] border-2 border-[#0477ad] justify-center items-center gap-[3.34px] flex">
              <div className="w-5 h-5 relative" />
            </div>
            <div className="grow shrink basis-0 h-[2.50px] bg-[#0477ad]" />
            <div className="w-[33.40px] h-[33.40px] p-[3.34px] bg-[#c5dfff] rounded-[33.40px] border-2 border-[#0477ad]" />
            <div className="grow shrink basis-0 h-[2.50px] bg-[#0477ad]" />
            <div className="w-[33.40px] h-[33.40px] p-[3.34px] rounded-[33.40px] border-2 border-[#0477ad]" />
          </div>
          <div className="self-stretch px-1 justify-between items-start inline-flex">
            <div className="text-[#3d4245] text-base font-semibold font-inter">
              Acta
            </div>
            <div className="text-[#3d4245] text-base font-semibold font-inter">
              Detalles
            </div>
            <div className="text-[#3d4245] text-base font-semibold font-inter">
              Foto
            </div>
          </div>
        </div>

        {datosConfirmarIngreso?.vehiculoDominio && (
          <div className=" w-[20rem] sm:w-[23rem] p-4 bg-white rounded-lg border border-[#c5dfff] flex-col justify-start items-start gap-3 flex">
            <div className="text-[#0a5477] text-sm font-bold font-inter uppercase">
              Vehículo
            </div>
            <div className="self-stretch flex-col justify-center items-start gap-2 flex">
              <div className="justify-start items-center gap-1 inline-flex">
                <div className="text-[#3d4245] text-lg font-bold font-inter">
                  Dominio:
                </div>
                <div className="text-[#687073] text-base font-medium font-inter">
                  {datosConfirmarIngreso.vehiculoDominio}
                </div>
              </div>
              <div className="justify-start items-center gap-1 inline-flex">
                <div className="text-[#3d4245] text-lg font-bold font-inter">
                  Tipo de vehículo:
                </div>
                <div className="text-[#687073] text-base font-medium font-inter">
                  {datosConfirmarIngreso.vehiculoTipo}
                </div>
              </div>
              <div className="justify-start items-center gap-1 inline-flex">
                <div className="text-[#3d4245] text-lg font-bold font-inter">
                  Marca:
                </div>
                <div className="text-[#687073] text-base font-medium font-inter">
                  {datosConfirmarIngreso.vehiculoMarca}
                </div>
              </div>
              <div className="justify-start items-center gap-1 inline-flex">
                <div className="text-[#3d4245] text-lg font-bold font-inter">
                  Modelo:
                </div>
                <div className="text-[#687073] text-base font-medium font-inter">
                  {datosConfirmarIngreso.vehiculoModelo}
                </div>
              </div>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className=" w-[20rem] sm:w-[23rem] flex-col justify-start items-start gap-5 inline-flex">
            <div className="self-stretch flex-col justify-start items-start gap-3 flex">
              <div className="self-stretch h-[75px] flex-col justify-start items-start gap-2 flex">
                <div className="text-[#3d4245] text-sm font-normal font-inter">
                  Sector
                </div>

                <select
                  className="w-full text-sm font-normal font-inter outline-none rounded-md pl-4 pr-10 py-2 h-[50px]"
                  defaultValue=""
                  {...register("sector", {
                    required: "Ingrese un sector por favor",
                  })}
                >
                  {Array.from({ length: 26 }, (_, i) => {
                    const letter = String.fromCharCode(65 + i); // 65 es el código ASCII de 'A'
                    return (
                      <option key={letter} value={letter}>
                        {letter}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="self-stretch h-[75px] flex-col justify-start items-start gap-2 flex">
                <div className="text-[#3d4245] text-sm font-normal font-inter">
                  Estado
                </div>

                <select
                  className="w-full text-sm font-normal font-inter outline-none rounded-md pl-4 pr-10 py-2 h-[50px]"
                  defaultValue="ingresado"
                  {...register("estado", {
                    required: "Ingrese un estado por favor",
                  })}
                >
                  <option value="Ingresado">Ingresado</option>
                  <option value="Desconocido">Desconocido</option>
                </select>
              </div>
              <div className="self-stretch h-[75px] flex-col justify-start items-start gap-2 flex">
                <div className="text-[#3d4245] text-sm font-normal font-inter">
                  Fecha y hora de ingreso
                </div>

                <input
                  name="fecha_hora"
                  placeholder="0"
                  type="datetime-local"
                  defaultValue={(() => {
                    const now = new Date();

                    const pad = (n) => n.toString().padStart(2, '0');

                    const year = now.getFullYear();
                    const month = pad(now.getMonth() + 1);
                    const day = pad(now.getDate());
                    const hours = pad(now.getHours());
                    const minutes = pad(now.getMinutes());

                    return `${year}-${month}-${day}T${hours}:${minutes}`;
                  })()}
                  className="w-full  text-sm font-normal font-inter outline-none rounded-md pl-4  py-2 h-[50px]"
                  {...register("fecha_hora", {
                    required: "Por favor, ingrese la fecha y hora.",
                    validate: (value) => {
                      const selectedDate = new Date(value);
                      const now = new Date();
                      const threeYearsAgo = new Date();
                      threeYearsAgo.setFullYear(now.getFullYear() - 3);

                      if (selectedDate > now) {
                        return "La fecha no puede ser superior a la actual";
                      }
                      if (selectedDate < threeYearsAgo) {
                        return `El año no puede ser menor a ${threeYearsAgo.getFullYear() + 1
                          }`;
                      }
                      return true; // La fecha es válida
                    },
                  })}
                />
              </div>
            </div>
            <div className="self-stretch justify-start items-center gap-2 inline-flex">
              <Button
                variant="secondary"
                size="lg"
                onClick={handleback}
                className="grow shrink basis-0"
              >
                Volver atrás
              </Button>
              <Button
                size="lg"
                type="submit"
                className="grow shrink basis-0"
              >
                Siguiente
              </Button>
            </div>
          </div>
        </form>
        <div className=" justify-center items-center text-center">
          {Object.values(errors).map((error, index) => (
            <p className="text-red-500" key={index}>
              {error.message}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}

export default IngresoDetallesComponent;
